import React from "react";
import styled from "styled-components";
import IconButton from "@common/LifeAtButton/Variants/IconButton";
import SidebarToggleIcon from "@icons/SidebarToggleIcon.svg";

const StyledIconButton = styled(IconButton)`
    margin-left: 10px;
`;

const StyledSidebarToggleIcon = styled(SidebarToggleIcon)`
    stroke: ${({ theme }) => theme.iconColor};
    stroke-width: 1.5;
`;

interface ToggleSidebarButtonProps {
    readonly toggleSidebar: () => void;
}
function ToggleSidebarButton(props: ToggleSidebarButtonProps) {
    return (
        <StyledIconButton
            className={`sidebar-toggle-button`}
            variant={"normal"}
            size={"small"}
            onClick={props.toggleSidebar}
        >
            <StyledSidebarToggleIcon />
        </StyledIconButton>
    );
}

export default ToggleSidebarButton;
